// @ts-expect-error untyped dependency, depends on creating types for checked.record
import { isSupportedCrmObject } from 'reporting-data/crmObjects/utils';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { isImmutableJourneyReport } from 'reporting-snowflake/funnel/types/journeyReport';
import { REPORT_TEMPLATE } from './Usage';
export const getShowSingleReportViewer = report => {
  return report.getIn(['config', 'configType']) !== 'NOTE';
};
export const getDataType = report => isSupportedCrmObject(report.getIn(['config', 'dataType'])) ? report.getIn(['config', 'objectTypeId']) : report.getIn(['config', 'dataType']);
export const refreshReportSuccess = (report, setRefreshStatusSuccess, notifyRefreshReportSuccess, updateRefreshCount) => {
  if (report.has('reportDefinition') || isImmutableJourneyReport(report)) {
    setRefreshStatusSuccess();
  }
  notifyRefreshReportSuccess(report);
  // updates refresh count after a refresh was successful (cache is successfully updated)
  updateRefreshCount();
};
export const reportSettled = (report, setDataset, setRefreshStatusSuccess, resolveResult) => {
  if (!resolveResult) {
    return;
  }
  if (report.has('reportDefinition')) {
    setDataset(resolveResult);
  } else if (isImmutableJourneyReport(report)) {
    const journeyDataset = Dataset(resolveResult.getIn(['resolveDatamap', 'primary']));
    setDataset(previousJourneyDataset => {
      if (previousJourneyDataset && previousJourneyDataset.equals(journeyDataset)) {
        return previousJourneyDataset;
      }
      return journeyDataset;
    });
  } else {
    try {
      setDataset(resolveResult.data.getIn(['primary', 'data']));
      setRefreshStatusSuccess();
    } catch (error) {
      console.warn('Error setting dataset', error);
    }
  }
};
export const closeClick = (previewReportChanged, use, setShowWarningModal, editReportSettingsProblem, onClose) => {
  if (!editReportSettingsProblem && previewReportChanged && use !== REPORT_TEMPLATE) {
    setShowWarningModal(true);
  } else if (onClose) {
    onClose();
  }
};